module.exports = "/_next/static/images/65bf25262acf33d96476a6bb4c38c164-mockup-transfer-fgts@3x.jpg.webp";